export default __webpack_public_path__ + "static/media/photo--sm--24.fd3f1778.jpg";